import type { Context } from 'root/utils/errorReporting/LoggingHandler';
import { getEndpoint } from '@lightspeedhq/mkt-endpoint-utils';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

const doFetch = async <T>(
    url: string,
    errorLogObject?: Context,
    callback?: (data: T, ...args: unknown[]) => unknown,
    errCallback?: (...args: unknown[]) => T | undefined,
    config?: RequestInit,
    callbackArgs: unknown[] = []
): Promise<T | undefined> => {
    try {
        const response = await fetch(getEndpoint(url), config);
        if (response.ok) {
            const data = (await response.json()) as T;
            if (callback) {
                const obj = typeof data === 'string' ? JSON.parse(data) : data;
                callback(obj, ...callbackArgs);
            }
            return data;
        } else {
            if (errCallback) {
                return errCallback(...callbackArgs);
            }
        }
    } catch (e) {
        if (errorLogObject && errorLogObject.additionalData) {
            const additionalData = errorLogObject.additionalData as Record<
                string,
                unknown
            >;
            additionalData.errorMessage =
                e instanceof Error ? e.message : JSON.stringify(e);
        }
        LoggingHandler().logError(e, errorLogObject);
        if (errCallback) {
            return errCallback(...callbackArgs);
        }
    }
};

export default doFetch;
